import { topicsData } from '@/mocks/home';

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-16 scroll-mt-20" style={{ backgroundColor: 'oklch(var(--background-100))' }}>
      <div className="w-full max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">话题标签</h2>
          <p className="text-sm text-foreground-500 mt-2">探索你感兴趣的漫画类型</p>
        </div>

        <div className="flex flex-wrap justify-center gap-3 max-w-4xl mx-auto">
          {topicsData.map((topic) => (
            <div
              key={topic.name}
              className="group flex items-center gap-2 px-5 py-2.5 rounded-full cursor-pointer transition-all duration-200 border"
              style={{
                borderColor: topic.hot ? 'oklch(var(--primary-300))' : 'oklch(var(--background-300))',
                backgroundColor: topic.hot ? 'oklch(var(--primary-50))' : 'oklch(var(--background-50))',
              }}
            >
              <span
                className="text-sm font-medium whitespace-nowrap"
                style={{ color: topic.hot ? 'oklch(var(--primary-700))' : 'oklch(var(--foreground-700))' }}
              >
                {topic.name}
              </span>
              <span className="text-xs text-foreground-400">{topic.count}</span>
              {topic.hot && (
                <span className="text-xs px-1.5 py-0.5 rounded" style={{ backgroundColor: 'oklch(var(--accent-100))', color: 'oklch(var(--accent-600))' }}>
                  热门
                </span>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}